import { render, staticRenderFns } from "./TeacherScheduledLessons.vue?vue&type=template&id=5ed2cdd2&scoped=true&"
import script from "./TeacherScheduledLessons.vue?vue&type=script&lang=js&"
export * from "./TeacherScheduledLessons.vue?vue&type=script&lang=js&"
import style0 from "./TeacherScheduledLessons.vue?vue&type=style&index=0&id=5ed2cdd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed2cdd2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VBtn,VCard,VCardTitle,VChip,VDivider})
